import React, { useRef, useState } from "react";
import { Tooltip, Popover } from "@mui/material";
import { IconButton } from "@mui/material";

const MessageA1 = (props) => {
  const [clicked, setClicked] = useState(false);

  const onClickHandler = (e) => {
    if (!props.disable) {
      props.handleClick(props.item.code);
      props.setTextOnClick(props.item.text);
      setClicked(true);
    }
  };

  return (
    <>
      {props?.item?.infoText ? (
        <Tooltip
          style={{ background: "#fff" }}
          title={
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <h1 style={{ fontSize: 13, margin: 0 }}>
                {props?.item?.infoText}
              </h1>
            </div>
          }
          placement="top"
        >
          <button
            className={
              !props.disable
                ? "chat-label action-tab"
                : "chat-labelnohover action-tab"
            }
            id="main-tab1"
            style={{
              color: clicked && "grey",
              pointerEvents: clicked && "none",
            }}
            onClick={onClickHandler}
          >
            {props.item.text}
          </button>
        </Tooltip>
      ) : props?.isFallback && props?.item?.text === "Chat with us" ? (
        <>
          <button
            className={
              props.isFallback
                ? "chat-label-fallback action-tab"
                : "chat-labelnohover action-tab"
            }
            id="main-tab1"
            style={{
              color: clicked && "grey",
              pointerEvents: clicked && "none",
            }}
            onClick={onClickHandler}
          >
            {props?.item?.text}
          </button>
        </>
      ) : (
        <button
          className={
            props.isFallback ? "chat-label action-tab" : "chat-label action-tab"
          }
          id="main-tab1"
          style={{
            color: clicked && "grey",
            pointerEvents: clicked && "none",
          }}
          onClick={onClickHandler}
        >
          {props?.item?.text}
        </button>
      )}
    </>
  );
};

export default MessageA1;
